const normalizeType = (type) => String(type || "").trim().toUpperCase();

const normalizeNumbers = (bet) => {
  const values = Array.isArray(bet)
    ? bet
    : String(bet || "").trim().split(/[\s,]+/);

  return values
    .map((value) => String(value).trim())
    .filter(Boolean);
};

export const lotteryBetKey = (bet) =>
  `${normalizeType(bet?.type)}:${normalizeNumbers(bet?.bet).join(":")}`;

export const mergeLotteryBets = (currentBets = [], incomingBets = []) => {
  const merged = currentBets.map((bet) => ({
    ...bet,
    amount: Number(bet.amount || 0),
    type: normalizeType(bet.type),
    bet: normalizeNumbers(bet.bet).join(" "),
  }));
  const indexByKey = new Map(
    merged.map((bet, index) => [lotteryBetKey(bet), index])
  );

  incomingBets.forEach((incoming) => {
    const normalized = {
      ...incoming,
      amount: Number(incoming.amount || 0),
      type: normalizeType(incoming.type),
      bet: normalizeNumbers(incoming.bet).join(" "),
    };
    const key = lotteryBetKey(normalized);
    const existingIndex = indexByKey.get(key);

    if (existingIndex !== undefined) {
      merged[existingIndex] = {
        ...merged[existingIndex],
        amount: Math.round(
          (merged[existingIndex].amount + normalized.amount) * 100
        ) / 100,
      };
      return;
    }

    indexByKey.set(key, merged.length);
    merged.push(normalized);
  });

  return merged;
};

export const formatLotteryBets = (bets = []) =>
  bets
    .map((bet) => `$${bet.amount} ${normalizeType(bet.type)} ${normalizeNumbers(bet.bet).join(" ")}`)
    .join("\n");
